module.exports = __webpack_public_path__ + "img/worldCupBannerPc.5d34d388.png";